import {
    DELETE_ACCESS_POINTS_ACCESS_METHOD,
    DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
    DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
} from 'store/actions/types';

export const deleteAccessPointAccessMethod = (payload) => {
    return {
        type: DELETE_ACCESS_POINTS_ACCESS_METHOD,
        payload: payload,
    };
};

export const deleteAccessPointAccessMethodFailure = (error) => {
    return {
        type: DELETE_ACCESS_POINTS_ACCESS_METHOD_FAILURE,
        error: error,
    };
};

export const deleteAccessPointAccessMethodSuccess = (response) => {
    return {
        type: DELETE_ACCESS_POINTS_ACCESS_METHOD_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/accessPoints/access-methods/delete/deleteAccessPointAccessMethod.js